import React from 'react'
import type { ListItemIconProps as MuiListItemIconProps } from '@material-ui/core/ListItemIcon'
import MuiListItemIcon from '@material-ui/core/ListItemIcon'

export type ListItemIconProps = MuiListItemIconProps

function ListItemIcon(props: ListItemIconProps) {
  return <MuiListItemIcon {...props} />
}

export default ListItemIcon
